/**
 * Created by Mark on 22/04/2017.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action from '../application-actions.js';
import Translation from '../store/internationalization-store.js';
class ScreenService {

    getVerbModules(verbUid , packageUid , toIetf){

        return ApplicationServices.call(Constants.GET_VERBS , {verbUid:verbUid,
            packageUid:packageUid,
            toIetf:toIetf}).then(function(response){
            return response;
        }.bind(this))
    }

    getScreenModules(){

        return ApplicationServices.call(Constants.GET_SCREEN_MODULES , {screenUid:100}).then(function(response){
               Action.update(Constants.UPDATE_SCREEN_MODULES , response);
        });
    }

    getModules(screenUid){

        return ApplicationServices.call(Constants.GET_SCREEN_MODULES , {screenUid:screenUid}).then(function(response){
                return response;
        });
    }

    getMap(curriculumID , learning , support){
        support = Translation.determineLocaleFromBrowser();

        return ApplicationServices.call(Constants.GETMAP , {support:support.substring( 0, 2), learning:learning , curriculumID:curriculumID}).then(function(response){
            return response.map;
        });
    }

    getSentenceBuilding(screenUid , packageUid, toIetf){
        return ApplicationServices.call(Constants.GET_SENTENCE_FOR_CURRICULUM, {toIetf:toIetf , screenUid:screenUid , packageUid:packageUid}).then(function(response){
            return response;
        });
    }

    getGrammar(screenUid , packageUid, toIetf){
        return ApplicationServices.call(Constants.GET_GRAMMAR_FOR_CURRICULUM, {toIetf:toIetf , screenUid:screenUid , packageUid:packageUid}).then(function(response){
            return response;
        });
    }
}

export default new ScreenService();